<template>
  <tr :class="{'clickable': $can('edit', 'YachtType')}">
    <td>
      {{ yachtType.label }}
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'YachtTypeRow',
    props: {
      yachtType: {
        type: Object,
        default: null
      }
    }
  }
</script>
